<template>
  <div class="videos">
    <div @click="handleClickVideo" style="position: relative;">
      <Swiper
        ref="swiper"
        class="swiper"
        :options="swiperOptions"
        @ready="onSwiperReady"
        @slideChange="onSwiperSlideChange"
      >
        <template v-for="(key, index) in Object.values(dataSource)">
          <SwiperSlide v-if="key.source.value" :key="index" class="swiper-slide">
            <div class="swiper-slider-content-wrapper">
              <video :id="'video-' + index" :src="key.source.value" />
              <div class="play-icon" :data-index="index"></div>
            </div>
          </SwiperSlide>
        </template>
      </Swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="video-title-list">
      <div class="line"></div>
      <template v-for="(value, index) in Object.values(dataSource)">
        <div
          v-if="value.name.value"
          :key="index"
          :class="['title-item', activeIndex === index ? 'title-item-active' : '']"
          :style="{ 'margin-left': index * 30 + 'px' }"
          @click="handleChangeIndex(index)"
        >
          <span>{{ value.name.value }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getFirstFrame } from "@/plugins/util";

export default {
  name: "Video",
  components: { Swiper, SwiperSlide },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      swiperOptions: {
        height: 540,
        direction: "vertical",
        slidesPerView: "auto",
        centeredSlides: true,
        // spaceBetween: -100,
        watchSlidesProgress: true,
        loop: true,
        loopedSlides: 5,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i);
              const slideProgress = this.slides[i].progress;

              let modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              const translate = slideProgress * modify * 310 + "px";
              const scale = 1 - Math.abs(slideProgress) / 10;
              const zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform("translateY(" + translate + ") scale(" + scale + ")");
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
          slideChange() {
            setTimeout(() => {
              this.slides.each((index, slide) => {
                /** @type {HTMLDivElement} */
                slide = slide;
                /** @type {HTMLVideoElement} */
                const video = slide.querySelector("video");
                video.removeAttribute("controls");
                if (this.activeIndex === index) {
                  video.onmouseenter = event => {
                    video.setAttribute("controls", "");
                  };
                  video.onmouseleave = event => {
                    video.removeAttribute("controls");
                  };
                  video.onplay = () => {
                    slide.querySelector("div.play-icon").remove();
                  };
                  video.onended = () => {
                    const div = document.createElement("div");
                    div.setAttribute("data-" + Object.keys(video.dataset)[0], "");
                    div.dataset.index = index;
                    div.classList.add("play-icon");
                    [...video.parentElement.querySelectorAll("div.play-icon")].forEach(el => el.remove());
                    video.parentElement.append(div);
                  };
                } else {
                  video.onmouseenter = null;
                  video.onplay = null;
                  video.onended = null;
                  video.pause();
                }
                if (this.activeIndex === index) {
                  slide.style.opacity = 1;
                } else if (Math.abs(this.activeIndex - index) === 1) {
                  slide.style.opacity = 0.8;
                } else {
                  slide.style.opacity = 0.6;
                }
              });
            }, 500);
          }
        }
      },
      playIndex: -1,
      activeIndex: 0
    };
  },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper;
    }
  },
  methods: {
    onSwiperReady() {
      // this.swiper.slides.each((index, slide) => {
      //   const video = slide.querySelector("video");
      //   getFirstFrame(video.src).then(poster => {
      //     video.setAttribute("poster", poster);
      //   });
      // });
    },
    onSwiperSlideChange() {
      this.activeIndex=this.swiper.realIndex
    },
    handlePlay(index) {
      /** @type {HTMLVideoElement} */
      const video = document.querySelector(`div.swiper-slide-active #video-${index}`);
      if (video) {
        this.playIndex = index;
        video.play();

        video.addEventListener(
          "ended",
          () => {
            const div = document.createElement("div");
            div.setAttribute("data-" + Object.keys(video.dataset)[0], "");
            div.dataset.index = index;
            div.classList.add("play-icon");
            [...video.parentElement.querySelectorAll("div.play-icon")].forEach(el => el.remove());
            video.parentElement.append(div);
          },
          { once: true, capture: true }
        );
      }
    },
    handlePause() {
      this.playIndex = -1;
    },
    handleEnded() {
      this.playIndex = -1;
    },
    handleClickVideo(event) {
      /** @type {HTMLDivElement} */
      const target = event.target;
      const index = target.dataset.index;
      if (index) {
        target.remove();
        this.handlePlay(index);
        setTimeout(() => {
          this.handlePlay(index);
        }, 300);
      }
    },
    handleChangeIndex(index) {
      this.activeIndex = index;
      this.swiper.slideTo(index);
    },
    slideTopChange() {
      const swiperTop = this.$refs.swiperTop.$swiper;

      this.activeIndex = swiperTop.activeIndex;
      // 其他的视频停止播放
      const videos = document.querySelectorAll(".video-info video");
      for (let i = 0; i < videos.length; i++) {
        videos[i].pause();
      }
      // 播放
      this.handlePlay(this.activeIndex);
    }
  }
};
</script>

<style lang="less" scoped>
.videos {
  position: relative;
  z-index: 3;
}
.swiper {
  width: 688px;
  height: 540px;
  .swiper-slide {
    height: 388px;
  }
  .swiper-slider-content-wrapper {
    height: 388px;
    background: url("~@/assets/nikke_imgs/video-bg.png") center/100% 100% no-repeat;
    video {
      width: 688px;
      height: 388px;
      object-fit: contain;
      background: #e3e3e3;
      clip-path: polygon(
        1% 8%,
        4% 1%,
        18% 1%,
        21% 4%,
        98% 4%,
        99.5% 7%,
        99.5% 94%,
        89% 94%,
        87% 98%,
        31% 98%,
        2% 98%,
        1% 96%
      );
    }
    .play-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      width: 66px;
      height: 66px;
      background: rgba(0, 0, 0, 0.65);
      border-radius: 50%;
      cursor: pointer;
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        border-left: 30px solid #fff;
        margin-left: 10px;
      }
    }
  }
}
.video-title-list {
  position: relative;
  .line {
    position: absolute;
    left: 26px;
    top: 0;
    height: 120%;
    background-image: linear-gradient(to bottom, rgba(202, 205, 212, 1), rgba(202, 205, 212, 0));
    width: 1px;
    transform: rotate(-28deg);
    &::before {
      content: "";
      position: absolute;
      top: -24px;
      left: 7px;
      width: 1px;
      height: 30px;
      transform: rotate(28deg);
      background-image: linear-gradient(
        to top,
        rgba(202, 205, 212, 1),
        rgba(202, 205, 212, 1) 50%,
        rgba(202, 205, 212, 0)
      );
    }
    &::after {
      content: "";
      position: absolute;
      width: 7px;
      height: 3px;
      background-color: rgb(62, 170, 247);
      top: 0;
      left: -2px;
      transform: rotate(28deg);
    }
  }
  .title-item {
    height: 25px;
    line-height: 25px;
    background-position: left center;
    background-size: 19px 19px;
    background-image: url("~@/assets/nikke_imgs/video-title.png");
    background-repeat: no-repeat;
    color: rgba(20, 38, 48, 0.6);
    font-size: 13px;
    padding-left: 50px;
    margin: 20px 0;
    cursor: pointer;
  }
  .title-item-active {
    background-size: 25px 25px;
    background-image: url("~@/assets/nikke_imgs/video-title-active.png");
    color: #142630;
    font-size: 15px;
  }
}
.swiper-button-prev {
  width: 46px;
  height: 30px;
  color: #fff;
  margin-top: -35px;
  background: rgba(0, 0, 0, 0.35);
  left: 50%;
  transform: translateX(-50%);
  top: 72px;
  background: url("~@/assets/nikke_imgs/video-arrow-prev.png") center/cover no-repeat;
}
.swiper-button-next {
  left: 180px;
  background: rgba(0, 0, 0, 0.35);
  left: 50%;
  width: 46px;
  height: 30px;
  color: #fff;
  margin-top: -35px;
  background: rgba(0, 0, 0, 0.35);
  right: 180px;
  bottom: 22px;
  top: unset;
  transform: translateX(-50%);
  background: url("~@/assets/nikke_imgs/video-arrow-next.png") center/cover no-repeat;
}
.swiper-button-prev::after,
.swiper-button-next::after {
  display: none;
}
</style>
